// extracted by mini-css-extract-plugin
module.exports = {"products":"tQ","oosMessaging":"uQ"};